import { useAppDispatch } from "config/store";
import { authActions } from "config/store/modules/auth.ts";
import { tryAsyncFunc } from "globals/functions/async.ts";
import ajax from "config/ajax.ts";
import { useLocation, useNavigate } from "react-router-dom";
import { Form, Formik } from "formik";
import Button from "components/atom/button/Button.tsx";
import LoadingContainer from "components/container/LoadingContainer.tsx";
import Input from "components/atom/Input.tsx";
import { useTranslation } from "react-i18next";
import designerPng from "assets/images/designer.png";
import useQuery from "utils/effects/useQuery.ts";
import { USER_TYPES } from "globals/constants.ts";

function ChangePassword() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const query = useQuery();


  const values = {
    token: query.token,
    password: "",
    confirmPassword: ""
  };

  return (

    <div className="w-full">
      <img src={designerPng} className="mx-auto block h-[220px] w-auto" />
      <h2 className="pb-3 text-center font-semibold">
        {t("auth.changePwdTitle")}
      </h2>
      <Formik
        initialValues={values}
        validateOnChange={false}
        validateOnBlur={false}
        validate={values => {
          const errors: Partial<{ [K in keyof typeof values]: string }> = {};//same keys as type but with string value
          if (!values.token) {
            errors.token = t("forms.errors.tokenInvalid");
          }
          if (!values.password) {
            errors.password = t("forms.errors.requiredPassword");
          }

          if (!values.confirmPassword) {
            errors.confirmPassword = t("forms.errors.requiredPassword");
          }
          if (values.confirmPassword !== values.password) {
            errors.confirmPassword = t("forms.errors.validateConfirmPassword");
          }
          return errors;
        }}
        onSubmit={async (values, { setSubmitting, setStatus, setFieldError }) => {
          setSubmitting(true);
          setStatus(null);

          const [res, err] = await tryAsyncFunc(ajax.put("/public/auth/change-pwd", {
            token: values.token,
            password: values.password
          }));
          setSubmitting(false);

          if (err) {
            const errData = err.response.data || {};
            const errors = errData.errors || {};

            if (errors.global) {
              setStatus(errors.global);
              delete errors.global;
            }

            Object.keys(errors).forEach(errKey => {
              setFieldError(errKey, errors[errKey]);
            });
            return;
          }

          await dispatch(authActions.setJwt(res.data.jwt));
          await dispatch(authActions.setUser(res.data.user));

          if (res.data.user.unverifiedEmail && res.data.user.type === USER_TYPES.EVENT_MANAGER && res.data.user.email === res.data.user.unverifiedEmail) {
            navigate({
              pathname: location.pathname,
              hash: "#/auth/verify-email"
            }, { state: { email: res.data.user.unverifiedEmail, coming_from: "click" } });
            return;
          }

          if (location.state && location.state.redirect_to) {
            window.location.href = location.state.redirect_to;//hard refresh
            return;
          }

          navigate("/profile");
        }}
      >
        {({ isSubmitting, status }) => (
          <LoadingContainer isLoading={isSubmitting} keepChildren>
            <Form>
              <Input autoComplete="current-password" name="password" type="password"
                     label={t("forms.password")} />

              <Input autoComplete="current-password" name="confirmPassword" type="password"
                     label={t("forms.confirmPassword")} />


              {status && (
                <p className="error block">{status}</p>
              )}
              <div className="mt-4 flex w-full flex-row items-center justify-center">
                <Button className="w-full" type="submit" disabled={isSubmitting}>
                  {t("auth.forgotPwdBtn")}
                </Button>
              </div>
              <div className="mt-4 flex flex-row items-center justify-between gap-4">
                <Button small style="text" className="w-full"
                        to={{ pathname: location.pathname, hash: "#/auth/forgot-pwd" }}
                >
                  {t("restart")}
                </Button>
              </div>
            </Form>
          </LoadingContainer>
        )}
      </Formik>
    </div>
  );
}

export default ChangePassword;
